import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firestore";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { useUser } from "../context/userContext";
import { usePremiumCheck } from './hooks/usePremiumCheck';
import Header from "../Components/Header";

const Miniputi = () => {
  const [miniPaths, setMiniPaths] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { premium: userIsPremium, id: userId, loading: userLoading, userType } = useUser();
  const { isPremium } = usePremiumCheck(userId, userType);

  const effectivePremium = isPremium || userIsPremium;

  // Telegram WebApp инициализация (только для Telegram пользователей)
  useEffect(() => {
    if (userType === 'telegram' && window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
      
      window.Telegram.WebApp.BackButton.isVisible = true;
      window.Telegram.WebApp.BackButton.offClick();
      window.Telegram.WebApp.BackButton.onClick(() => {
        console.log('Back button clicked');
        navigate(-1);
      });
    }

    return () => {
      if (userType === 'telegram' && window.Telegram?.WebApp) {
        window.Telegram.WebApp.BackButton.isVisible = false;
        window.Telegram.WebApp.BackButton.offClick();
      }
    };
  }, [navigate, userType]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    const loadMiniPaths = async () => {
      try {
        const pathsRef = collection(db, "miniPaths");
        const q = query(pathsRef, orderBy("order", "asc"));
        const snap = await getDocs(q);

        const items = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        setMiniPaths(items);
      } catch (e) {
        console.error("Ошибка загрузки мини-путей:", e);
      } finally {
        setLoading(false);
      }
    };

    loadMiniPaths();
  }, []);

  const hasAccessToPath = (path) => {
    if (!path.premium) return true;
    if (!userId) return false;
    return effectivePremium;
  };

  const handlePathClick = (path) => {
    const hasAccess = hasAccessToPath(path);
    
    if (hasAccess) {
      navigate(`/MiniPath/${path.id}`);
    } else if (!userId) {
      alert("Авторизуйтесь для доступа");
    } else {
      alert("Этот мини-путь доступен только для Premium пользователей");
    }
  };

  if (loading || userLoading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center text-white relative">
        <div
          className="fixed inset-0"
          style={{
            backgroundImage: "url('/bghome.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: -1
          }}
        />
        <div className="relative z-10">Загрузка...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full text-white relative">
      <div
        className="fixed inset-0"
        style={{
          backgroundImage: "url('/bghome.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1
        }}
      />

      <div className="fixed bottom-0 left-0 right-0 h-[150px] bg-[radial-gradient(circle_at_center,rgba(120,0,255,0.15),transparent_70%)] z-0" />

      <div className="relative z-10 min-h-screen flex flex-col">
        <div className="pt-0">
          <Header />
        </div>
        
        <div className="flex-1 px-4 pt-6 pb-24 overflow-y-auto">
          <h1 className="text-white text-[18px] font-semibold mb-6">
            МИНИ-ПУТИ
          </h1>

          <div className="flex flex-col gap-4">
            {miniPaths.length === 0 ? (
              <div className="text-center text-white/60 py-8">
                Пока нет мини-путей
              </div>
            ) : (
              miniPaths.map((path) => {
                const hasAccess = hasAccessToPath(path);
                const isLocked = path.premium && !hasAccess;
                
                return (
                  <div
                    key={path.id}
                    className={`w-full rounded-[20px] border p-4 flex items-center gap-4 ${isLocked ? 'opacity-70' : ''}`}
                    style={{
                      background: "#241352",
                      borderColor: isLocked ? "#EF4444" : "rgba(255,255,255,0.2)"
                    }}
                  >
                    <div className="w-[72px] h-[72px] rounded-[12px] overflow-hidden shrink-0">
                      <img
                        src={path.image || "https://images.unsplash.com/photo-1545235617-9465d2a55698?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80"}
                        alt={path.title}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.target.src = "https://images.unsplash.com/photo-1545235617-9465d2a55698?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80";
                        }}
                      />
                    </div>

                    <div className="flex-1 flex flex-col justify-between min-h-[72px]">
                      <div>
                        <div className="flex items-center gap-2">
                          <div
                            className="text-[16px] leading-tight font-medium break-words whitespace-normal"
                            style={{ color: isLocked ? "#94A3B8" : "#C8AFE8" }}
                          >
                            {path.title}
                          </div>
                          {path.premium && (
                            <span className={`px-2 py-0.5 rounded-full text-xs ${hasAccess ? 'bg-yellow-500/20 text-yellow-300' : 'bg-red-500/20 text-red-300'}`}>
                              Premium
                            </span>
                          )}
                        </div>
                        
                        <div className="flex items-center gap-2 mt-1">
                          <div
                            className="text-[14px] font-medium"
                            style={{ color: isLocked ? "#EF4444" : "#34D3FF" }}
                          >
                            {isLocked ? "Заблокировано" : "Доступно"}
                          </div>
                          {path.slides && (
                            <div className="text-[12px] text-white/40">
                              {path.slides.length} {path.slides.length === 1 ? 'слайд' : 'слайдов'}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="mt-3">
                        <button
                          className={`px-6 py-2 rounded-full text-white text-[15px] font-medium active:scale-95 transition ${isLocked ? 'cursor-not-allowed' : 'hover:opacity-90'}`}
                          style={{
                            background: isLocked ? "#6B7280" : "#6B3FD8",
                          }}
                          onClick={() => handlePathClick(path)}
                          disabled={isLocked}
                        >
                          {isLocked ? "Заблокировано" : "Открыть"}
                        </button>
                        
                        {isLocked && path.premium && !effectivePremium && userId && (
                          <p className="text-xs text-yellow-400 mt-2 text-center">
                            Требуется Premium подписка
                          </p>
                        )}
                        
                        {isLocked && !userId && (
                          <p className="text-xs text-pink-400 mt-2 text-center">
                            Требуется авторизация
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Miniputi;